import { returnNonNull } from 'src/common/helpers/ArraysHelper';

import { IWfaLabel, IWfaSessionDetails } from '../../../WfaDashboardServiceTypes';
import { WfaSessionDetailsQuery } from '../WfaSessionDetails.generated';

const mapCustomFieldsToLabels = (customFields?: string[][]): IWfaLabel[] => {
	const labels = new Map<string, IWfaLabel>();

	customFields?.filter(returnNonNull).forEach(([labelKey, valueKey]) => {
		if (!labelKey || !valueKey) {
			return;
		}

		// Display all labels using raw key/value pairs
		const labelMapEntry = labels.get(labelKey);

		if (labelMapEntry) {
			labels.set(labelKey, {
				...labelMapEntry,
				values: [...labelMapEntry.values, { name: valueKey, key: valueKey }]
			});
			return;
		}

		labels.set(labelKey, {
			name: labelKey,
			key: labelKey,
			values: [{ name: valueKey, key: valueKey }]
		});
	});

	return Array.from(labels.values());
};

export const transformSessionDetailsResult = (
	rawResults: WfaSessionDetailsQuery,
	isLabelsToggleEnabled?: boolean
): IWfaSessionDetails => {
	const session = rawResults?.wfa_session_runs?.[0];
	return {
		sessionId: session?.run_id,
		name: session?.session_name,
		runTime: session?.run_time,
		lastModifiedTime: session?.update_time,
		totalIssues: session?.total_issues ?? 0,
		criticalIssues: session?.critical_issues ?? 0,
		domain: session?.domain,
		createdBy: session?.user_name,
		detectionTypes: session?.detection_types,
		focusArea: session?.analysis_root_selector,
		labels: isLabelsToggleEnabled ? mapCustomFieldsToLabels(session?.custom_fields) : []
	};
};
